import { ImportExportStatus } from '@/components/ImportExportHistory/type';
import { useTranslation } from '@/i18n';

export const useStatusLabel = (status: ImportExportStatus) => {
  const { t } = useTranslation();

  switch (status) {
    case 'processing':
      return t('import_export_history_status_processing');
    case 'done':
      return t('import_export_history_status_done');
    case 'failed':
      return t('import_export_history_status_failed');
    case 'canceled':
      return t('import_export_history_status_canceled');
    default:
      return '';
  }
};
